import { h } from 'preact'
import { signal } from '@preact/signals'
import { useLayoutEffect } from 'preact/hooks'
import { setAllToMaxHeight } from '../../js/modules/setAllToMaxHeight.js'
import { attachClampByQuery } from '../../js/modules/clamp.js'
import { isEmptyObject } from '../../js/modules/utilities.js'
import { attributesAnalytics } from '../../js/modules/component'
import replayImg from './yabusame.jpg'

export const tvLiveReplayState = signal('')
var tvLive = {}
var tvTonight = {}
var tvReplay = {}

export const TvLiveReplay = ({ title }) => {
   if (tvLiveReplayState.value !== '' && tvLiveReplayState.value['tvLive'] !== undefined) tvLive = tvLiveReplayState.value['tvLive']
   if (tvLiveReplayState.value !== '' && tvLiveReplayState.value['tvTonight'] !== undefined) tvTonight = tvLiveReplayState.value['tvTonight']
   if (tvLiveReplayState.value !== '' && tvLiveReplayState.value['tvReplay'] !== undefined) {
      tvReplay = tvLiveReplayState.value['tvReplay']
      tvReplay.show.image = replayImg
      tvReplay.show.alt = "Yabusame les amazones du soleil-levant"
      tvReplay.show.csaPicto = ""
      tvReplay.show.title = "Yabusame les amazones du soleil-levant"
      tvReplay.show.ariaLabel = "Yabusame les amazones du soleil-levant, Doc. évasion sur Arte"
      tvReplay.show.URL = "https://tv.orange.fr/fiche-info/replay/series/ATE1663603030360"
      tvReplay.show.genre = "Doc. évasion"
      tvReplay.show.channel = {
         "logo": "//proxymedia.woopic.com/api/v1/images/1127%2Fdefault",
         "name": "ARTE"
      }
      tvReplay.show.analytics["oevent-label"] = "https://tv.orange.fr/fiche-info/replay/series/ATE1663603030360"
      tvReplay.show.analytics["oevent-action"] = "yabusame-les-amazones-du-soleil-levant"
   }

   useLayoutEffect(() => {
      setAllToMaxHeight('.o-tv .btn')
      attachClampByQuery('.o-tv [data-clamp-line]')
   })

   return (
      <div class="pt-2 pb-2 pt-md-3 pt-md-3 mb-2 bg-dark o-tv" data-testid="bande-tv-prospect">
         <div class="container-fluid">
            <h2 class="title mb-1 mb-md-2 text-white">{title}</h2>

            <div class="row d-flex justify-content-between">
               {!isEmptyObject(tvLive) ? <Show {...tvLive} index="1" /> : ''}
               {!isEmptyObject(tvTonight) ? <Show {...tvTonight} index="2" /> : ''}
               {!isEmptyObject(tvReplay) ? <Show {...tvReplay} index="3" /> : ''}
            </div>
         </div>
      </div>
   )
}

const Show = ({ cacheKey, title, URL, analytics, show, CTA, index }) => {

   return (
      <div class="d-flex flex-column col-12 col-sm-6 col-md-4 text-white item mb-2 mb-md-1" data-cache-key={cacheKey} data-testid={`tv${index}`}>
         <a
            class="category-link"
            href={URL}
            {...attributesAnalytics(analytics)}
         >
            <h3 class="category-title mb-0 mb-md-1">{title}</h3>
         </a>
         <div class="mb-1 item-tv-visuel-container">
            <div
               class="lien-composite item-tv-visuel"
               {...attributesAnalytics(show.analytics)}
            >
               <div class="block-img" aria-hidden="true">
                  {show.image.startsWith('http') ? (
                     <img loading="lazy" src={show.image} alt="" class=" w-100" />
                  ) : (
                     <img loading="lazy" src={`${show.image}?saveas=webp&format=420x236`} alt="" class=" w-100" />
                  )}

                  {show.csaPicto !== '' ? (
                     <div class="csa_layer">
                        <div class={`csa csa_${show.csaPicto}`}></div>
                     </div>
                  ) : null}
               </div>

               {show.progressBar.progress > 0 && show.progressBar.progress <= 100 ? (
                  <div class="progress">
                     <div
                        class="progress-bar"
                        aria-label={show.progressBar.ariaLabel}
                        role="progressbar"
                        style={`width: ${show.progressBar.progress}%;`}
                        aria-valuenow={show.progressBar.progress}
                        aria-valuemin="0"
                        aria-valuemax="100"
                        aria-hidden="true"
                     ></div>
                  </div>
               ) : null}
               <div
                  class={`d-flex justify-content-between${!(show.progressBar.progress > 0 && show.progressBar.progress <= 100) ? ' item-tv-add-fake-gap' : ''}`}
                  aria-hidden="true"
               >
                  <p class="small mb-0 font-weight-bold time">{show.startEndTime}</p>
                  <span class="logo-wrapper">
                     <img
                        loading="lazy"
                        src={`${show.channel.logo}`}
                        alt={show.channel.name}
                        class="logo"
                        onerror={(event) => {
                           event.target.classList.add('d-none')
                           event.target.insertAdjacentHTML('afterend', event.target.alt)
                        }}
                     />
                  </span>
               </div>
               <a class="lead font-weight-bold p-0 pt-md-1" href={show.URL} aria-label={show.ariaLabel} data-clamp-line="2">
                  {show.title}
               </a>
               <p class="type p-0 pt-md-1" aria-hidden="true">
                  {show.genre}
               </p>
            </div>
         </div>
         <a
            class="btn btn-secondary btn-inverse align-self-center align-self-md-start mt-auto d-flex align-items-center"
            href={CTA.URL}
            {...attributesAnalytics(CTA.analytics)}
         >
            {CTA.label}
         </a>
      </div>
   )
}
